import React from "react";
import {
  ActivityIndicator,
  Button as RNButton,
  Keyboard,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  View,
} from "react-native";
import MenuButton from "../../components/MenuButton";
import WebHeading from "../../components/WebHeading";
import {errorColors, RepositStyles} from "../../utils/styles";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {attachKit, getKit, resetKit} from "../../redux/actions/kit";
import {insertSerialNum} from "../../redux/actions/box";
import goTo from "../../utils/goTo";
import Phone from "../../utils/Phone";
import Icon from "react-native-vector-icons/FontAwesome";
import storage from "../../utils/storage";
import {bootstrapKitDesign} from "../../redux/actions/designer";

const questionCircle = (
  <Icon name="warning" size={14} color={errorColors.orange} />
);

const mapStateToProps = (state) => ({
  kit: state.kit,
  box: state.box,
  customer: state.customer,
  permissions: state.user.permissions,
});

const mapDispatchToProps = (dispatch) => {
  return {
    kitActions: bindActionCreators(
      { getKit, resetKit, attachKit, insertSerialNum },
      dispatch
    ),
    designerActions: bindActionCreators({ bootstrapKitDesign }, dispatch),
  };
};

const styles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
  heading: {
    marginHorizontal: 20,
  },
  headingText: { fontSize: 24, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "left",
    fontSize: 18,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 20,
    marginVertical: 20,
  },
  textInputTitle: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
  },
  bodyText: {
    marginVertical: 10,
  },
  textInput: {
    fontSize: 16,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 300,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
  bodyTextContainer: {
    flex: 1,
    alignItems: "center",
  },
});

class KitSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      modalVisible: false,
      validationVisible: false,
      manuallyConfiguring: false,
    };
  }

  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };

  closeModal = () => {
    this.setState({ validationVisible: false });
  };

  closeModalAndNext = () => {
    if (Platform.OS !== "web") {
      Keyboard.dismiss();
    }
    this.props.kitActions.getKit(this.state.text);
  };

  openKitDesigner = () => {
    const { designerActions, navigation, permissions } = this.props;

    if (Platform.OS !== "web") {
      Keyboard.dismiss();
    }

    designerActions.bootstrapKitDesign();
    goTo(
      navigation,
      permissions.includes("installerapp.edmi") ? "EdmiSerial" : "SiteDetails"
    );
  };

  register = (kitId) => {
    const customer = this.props.customer.selectedSite;
    const kit = kitId;
    let serialNum = this.props.box.serialNumber;

    if (!serialNum) {
      console.log("LOADING FROM STORAGE");
      storage
        .load({ key: "serialNum" })
        .then((ret) => {
          this.props.kitActions.insertSerialNum(ret);
          this.props.kitActions.attachKit(kit, customer, ret);
        })
        .catch((err) => {
          console.log(err);
          this.props.kitActions.attachKit(kit, customer, serialNum);
        });
    } else {
      this.props.kitActions.attachKit(kit, customer, serialNum);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (Platform.OS !== "web" && !nextProps.navigation.isFocused()) {
      return;
    }

    if (nextProps.kit.status === "FOUND" && this.props.kit.status !== "FOUND") {
      this.register(nextProps.kit.kitComponents.id);
    } else {
      const nextCon = nextProps.kit.registrationStatus;
      const thisCon = this.props.kit.registrationStatus;
      if (nextCon === "SUCCESS" && thisCon !== "SUCCESS") {
        goTo(this.props.navigation, "ConnectionType");
      }
    }
  }

  render() {
    console.log(this.props.kit);
    return (
      <View style={styles.wrapper}>
        <WebHeading title="New Setup" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 800, maxHeight: 600 }}>
            <View style={{ flex: 3, justifyContent: "space-around" }}>
              <Text style={RepositStyles.headerText}>Enter Kit Number</Text>
              <Text style={RepositStyles.paragraphText}>
                The Kit Number is a 1 to 5 digit number printed on the packing
                slip, it identifies the type of system you're installing.
              </Text>
              <View style={styles.textInputWrapper}>
                <View style={styles.textInputContainer}>
                  <TextInput
                    placeholder="Kit Number"
                    autoCorrect={false}
                    keyboardType="numeric"
                    onChangeText={(text) => this.setState({ text: text })}
                    value={this.state.text}
                    style={styles.textInput}
                    onSubmitEditing={() => this.closeModalAndNext()}
                  />
                </View>
              </View>
              <View>
                {this.props.kit.status === "NOT FOUND" ? (
                  <Text style={[RepositStyles.paragraphText]}>
                    {questionCircle} Unable to find that Kit. If you're having
                    trouble finding your kit number,{" "}
                    <Phone>call Reposit on</Phone>
                  </Text>
                ) : this.props.kit.registrationStatus === "ERROR" ? (
                  <Text style={RepositStyles.paragraphText}>
                    {questionCircle} Unable to register kit. Please try against
                    or
                    <Phone> call Reposit on</Phone>
                  </Text>
                ) : null}
              </View>
              {this.props.permissions.includes("fleet.kit_designer") ? (
                <View>
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      textAlign: "center",
                    }}
                  >
                    No Kit Number?
                  </Text>
                  <View style={{ alignSelf: "center" }}>
                    <RNButton
                      onPress={this.openKitDesigner}
                      title=" Manually Configure Kit "
                      color="#4698CB"
                    />
                  </View>
                </View>
              ) : null}
            </View>

            <View
              style={{
                flex: 2,
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: -40,
              }}
            >
              {this.props.kit.status === "FETCHING" ||
              this.props.kit.registrationStatus === "ATTACHING" ? (
                <ActivityIndicator />
              ) : (
                <RNButton
                  onPress={this.closeModalAndNext}
                  title=" Next "
                  color="#4698CB"
                ></RNButton>
              )}
              <Text style={RepositStyles.nextSub}>Verify Kit</Text>
            </View>
            <View style={{ flex: 1 }} />
          </View>
        </View>
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(KitSelector);



// WEBPACK FOOTER //
// ./src/containers/kit/KitNumber.js